<script lang="ts">
  import { Col, Label, Row } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import { Animatedradiobuttons } from "../../../../utils/Constant/Constant";
</script>
<Col md="6">
  <Card cardHeaderprops="pb-0" headerTitle={Animatedradiobuttons} cardBodyprops="animate-chk">
    <div slot="contentbody">
      <Row>
        <Col>
          <Label class="d-block" for="edo-ani">
            <input class="radio_animated" id="edo-ani" type="radio" name="rdo-ani" checked> {'Option 1'}
          </Label>
          <Label class="d-block" for="edo-ani1">
            <input class="radio_animated" id="edo-ani1" type="radio" name="rdo-ani">  {'Option 2'}
          </Label>
          <Label class="d-block" for="edo-ani2">
            <input class="radio_animated" id="edo-ani2" type="radio" name="rdo-ani" checked> {'Option 3'}
          </Label>
          <Label class="d-block" for="edo-ani13">
            <input class="radio_animated" id="edo-ani13" type="radio" name="rdo-ani"> {'Option 4'}
          </Label>
        </Col>
      </Row>
    </div>
  </Card>
</Col>